<template>
  <div id="bottomInfo">
    <!-- <div class="leftEmpty"></div> -->
    <div class="centerAuto">
      <div class="infoBox">
        <div class="card-item">
          <div class="title">集团业务</div>
          <div class="subTitle hoverColor">
            <div
              v-for="(item, index) in groupBusinessList"
              :key="index"
              @click="toPathGroupBusiness(index)"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="card-item">
          <div class="title">人才发展</div>
          <div class="subTitle hoverColor">
            <div
              v-for="(item, index) in talentDevelopList"
              :key="index"
              @click="toPathTalentDevelop(index)"
            >
              {{ item }}
            </div>
            <!-- <div>社会招聘</div>
            <div>校园招聘</div> -->
            <!-- <div>实习生招募</div>
            <div>培训政策</div>
            <div>培训体系</div> -->
          </div>
        </div>
        <div class="card-item">
          <div class="title">关于家政</div>
          <div class="subTitle hoverColor">
            <div
              v-for="(item, index) in aboutList"
              :key="index"
              @click="toPathAboutTeam(index)"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="card-item">
          <div class="title">联系方式</div>
          <div class="subTitle">
            <div class="hotLine">24小时免费咨询热线</div>
            <div class="dateWeek">周一至周日</div>
            <div class="telPhone">{{ informationData.customerPhone }}</div>
          </div>
        </div>
        <div class="about-us-item">
          <div class="title">关于我们</div>
          <div class="subTitle">
            <div class="leftImg">
              <img :src="informationData.xiaochengxu" alt="erweima" />
              <div class="xiaochengxu">正华源家政</div>
            </div>
            <div class="rightImg">
              <img :src="informationData.rencaiku" alt="erweima" />
              <div>正华源人才库</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div style="margin-top: 18px; margin-bottom: -12px">
        <span style="margin-right: 5px">{{
          `公司总机: ${informationData.customerPhone}`
        }}</span>
        <span style="margin-right: 5px">备案号: 粤ICP备2023089155号</span>
        <span>{{ `${informationData.address}` }}</span>
      </div>
      <br />
      Copyright@2023 深圳正华源文教集团有限公司 版权所有
    </div>
    <!-- <div class="rightEmpty"></div> -->
  </div>
</template>

<script>
export default {
  props: ["informationData"],
  data() {
    return {
      groupBusinessList: ["教育", "家政", "数据运营", "基金"],
      talentDevelopList: ["社会招聘", "校园招聘"],
      aboutList: [
        "集团概况",
        "企业文化",
        "领导寄语",
        "我们的团队",
        "集团架构",
        "荣誉资质",
        "员工风采",
      ],
    };
  },
  methods: {
    toPathGroupBusiness(index) {
      this.$router.push({
        path: "/home/groupBusiness",
        query: {
          index,
        },
      });
      this.$nextTick(() => {
        document.getElementById("web-center").scrollTop = 0;
      });
    },
    toPathTalentDevelop(index) {
      this.$router.push({
        path: "/home/talentDevelop",
        query: {
          index,
        },
      });
      this.$nextTick(() => {
        document.getElementById("web-center").scrollTop = 0;
      });
    },
    toPathAboutTeam(index) {
      this.$router.push({
        path: "/home/aboutTeam",
        query: {
          index,
        },
      });
      this.$nextTick(() => {
        document.getElementById("web-center").scrollTop = 0;
      });
    },
  },
};
</script>

<style lang="scss">
#bottomInfo {
  padding-top: 54px;
  width: 100%;
  // height: 374px;
  background: #f6f6f6;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .infoBox {
    display: flex;
    width: 1200px;
    margin-bottom: 13px;
    .card-item,
    .about-us-item {
      flex: 1;
      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        margin-bottom: 38px;
      }
      .subTitle {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #553a3a;
        div {
          margin-bottom: 16px;
        }
      }
      .hoverColor {
        div {
          margin-bottom: 16px;
          cursor: pointer;
          &:hover {
            color: #e02020;
          }
        }
      }
      .hotLine,
      .dateWeek {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #553a3a;
      }
      .hotLine {
        margin-bottom: 4px !important;
      }
      .dateWeek {
        margin-bottom: 10px !important;
      }
      .telPhone {
        font-size: 23px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #351616;
        line-height: 33px;
      }
    }
  }
  .leftEmpty {
    // width: 360px;
    width: 18%;
    height: 100%;
  }
  .rightEmpty {
    width: 365px;
    width: 19%;
    height: 100%;
  }
  .centerAuto {
    flex: 1;
    border-bottom: 1px solid #e4e4e4;
  }
  .about-us-item {
    margin-left: 218px;
    .subTitle {
      display: flex;
      justify-content: space-between;
      img {
        width: 100px;
        height: 100px;
      }
      div {
        text-align: center;
        margin-top: 17px;
      }
    }
    .leftImg {
      margin-right: 55px;
    }
  }
  .copyright {
    margin-bottom: 15px;
    height: 65px;
    text-align: center;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #6d5656;
  }
}
</style>
